import React from 'react';
import { motion } from 'framer-motion';
import { RecoveryRing } from './ui/RecoveryRing';
export function OpeningHook() {
  return <section className="py-24 bg-brand-dark border-y border-brand-panelBorder relative overflow-hidden" data-id="element-143">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-brand-red/50 to-transparent" data-id="element-144" />

      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-146">
          <p className="text-2xl font-medium text-brand-gray mb-12" data-id="element-147">
            It's 7:00 AM. You reach for your phone, open your app, and wait.
          </p>

          <div className="flex flex-col items-center justify-center mb-12" data-id="element-148">
            <div className="relative bg-[#111] border border-brand-red/20 rounded-3xl p-8 shadow-[0_0_50px_rgba(255,51,85,0.1)]" data-id="element-149">
              <RecoveryRing score={38} color="red" size={160} strokeWidth={12} delay={0.5} data-id="element-150" />
              <div className="absolute -right-4 -top-4 bg-brand-red text-white text-xs font-bold px-3 py-1 rounded-full animate-pulse" data-id="element-151">
                WARNING
              </div>
            </div>
          </div>

          <div className="space-y-6 text-xl lg:text-3xl font-bold leading-tight" data-id="element-152">
            <p data-id="element-153">
              There it is. A{' '}
              <span className="text-brand-red" data-id="element-154">38% Readiness Score.</span> A red
              ring.
            </p>
            <p className="text-brand-gray" data-id="element-155">
              A warning that your day is already ruined. You feel tired because
              the data told you that you're tired.
            </p>
            <p className="text-white" data-id="element-156">
              You're trapped in the "Measurement Loop"—tracking your decline
              instead of steering your recovery.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}